<template>
  <div class="modal-mask" ref="mask">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <h2>Settings</h2>
        </div>
        <div class="modal-body">
        </div>
        <div class="modal-footer">
            <button @click="close(false)" class="modal-button modal-button__cancel">Cancel<span class="material-icon icon-arrow_right"></span></button>
            <button @click="close(true)" class="modal-button modal-button__save">Save<span class="material-icon icon-check"></span></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'OptionsPopup',
  mounted() {
    this.$refs.mask.focus();
  },
  data(){
    return {};
  },
  methods: {
    // close(true) will write newly selected settings to config.yml
    close(shouldSave){
      if (shouldSave) this.$emit('saveConfig');
      else this.$emit('loadConfig');
      this.$emit('close');
    }
  }
}
</script>